var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0625 0.125H4.6875C3.4443 0.125 2.25201 0.61886 1.37294 1.49794C0.49386 2.37701 0 3.5693 0 4.8125L0 39.1875C0 40.4307 0.49386 41.623 1.37294 42.5021C2.25201 43.3811 3.4443 43.875 4.6875 43.875H18.0908V29.001H11.9385V22H18.0908V16.6641C18.0908 10.5947 21.7041 7.24219 27.2383 7.24219C29.8887 7.24219 32.6602 7.71484 32.6602 7.71484V13.6719H29.6064C26.5977 13.6719 25.6592 15.5391 25.6592 17.4541V22H32.376L31.3018 29.001H25.6592V43.875H39.0625C40.3057 43.875 41.498 43.3811 42.3771 42.5021C43.2561 41.623 43.75 40.4307 43.75 39.1875V4.8125C43.75 3.5693 43.2561 2.37701 42.3771 1.49794C41.498 0.61886 40.3057 0.125 39.0625 0.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0e9f906d8fdcb709608c756d7fc0b624.svg";
export { ForwardRef as ReactComponent };